import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accountSSO: {}
  },
  mutations: {
    SET_ACCOUNT_DOMAINS (store, item) {
      store.accountSSO = item
    }
  },
  getters: {
    getAccountSSO: (store, getters) => {
      return store.accountSSO
    }
  },
  actions: {
    /*
    getAccountSSO
    */
    getAccountSSO ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}/account-sso`)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateAccountSSO
    */
    updateAccountSSO ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-sso`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountSSO.js